import React, { useState } from 'react'
import { Card, Form, Button, Badge, Placeholder } from 'react-bootstrap'
import LibraryMembershipResponse from "./LibraryMembershipResponse";
import CardBodyContentContainer from "../../../common/styles/CardBodyContentContainer";
import CardTitle from "../../../common/styles/CardTitle";
import BooksitoutIcon from "../../../config/BooksitoutIcon";
import { BooksitoutServer } from "../../../config/BooksitoutServer";
import { useParams } from "react-router-dom";
import toast from 'react-hot-toast';
import RowSpacer from "../../../common/styles/RowSpacer";

export const LibraryMembershipDetailStatusCardLoading: React.FC = () => {
    return (
        <Card style={{minHeight: '200px'}}>
            <CardBodyContentContainer height={200} backgroundColorType={'card'}>
                <CardTitle icon={<BooksitoutIcon.book/>} title={`대출 현황`} subTitle={undefined} textSize={2} url={''}/>

                <div style={{padding: '20px', textAlign: 'center'}}>
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                        <Placeholder as={Badge} bg="book" style={{fontSize: '1.2rem', padding: '8px 16px', width: '180px'}} animation="glow">
                            <Placeholder xs={12} />
                        </Placeholder>

                        <Placeholder as={Badge} bg="book" style={{fontSize: '1.2rem', padding: '8px 16px', width: '120px'}} animation="glow">
                            <Placeholder xs={12} />
                        </Placeholder>

                        <Placeholder as={Badge} bg="book" style={{fontSize: '1.2rem', padding: '8px 16px', width: '120px'}} animation="glow">
                            <Placeholder xs={12} />
                        </Placeholder>
                    </div>
                </div>
            </CardBodyContentContainer>
        </Card>
    )
}

const LibraryMembershipDetailStatusCard: React.FC<{membership: LibraryMembershipResponse}> = ({ membership }) => {
    const { membershipId } = useParams()
    const [homePageId, setHomePageId] = useState('')
    const [homePagePw, setHomePagePw] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!homePageId.trim() || !homePagePw.trim()) return

        setIsSubmitting(true)

        try {
            await BooksitoutServer.put(`/v1/library/membership/${membershipId}`, {
                homePageId: homePageId,
                homePagePw: homePagePw,
            })

            window.location.reload()
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || '알 수 없는 오류가 났어요. 잠시 후 다시 시도해 주세요.'
            toast.error(errorMessage)
        } finally {
            setIsSubmitting(false)
        }
    }

    if (!membership.isCredentialAdded || membership.status == null) {
        return (
            <Card style={{minHeight: '200px'}}>
                <CardBodyContentContainer height={200} backgroundColorType={'card'}>
                    <CardTitle icon={<BooksitoutIcon.book/>} title={`대출 현황`} subTitle={'도서관 홈페이지의 아이디/비밀번호를 입력하면 대출, 예약, 연체 현황을 볼 수 있어요.'} textSize={2} url={''}/>

                    <div className="row justify-content-center" style={{ padding: '20px' }}>
                        {/* Logo and Name - Left on desktop, Top on mobile */}
                        <div className="col-12 col-md-3 mb-3 mb-md-0 d-flex flex-column align-items-center justify-content-center">
                            {membership.type.homePageUrl ? (
                                <a
                                    href={membership.type.homePageUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none text-center"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <img src={membership.type.logo} alt={membership.type.name} style={{ width: '80px', marginBottom: '10px' }} />
                                    <RowSpacer size={5}/>
                                    <h5 className="text-center mb-0">{membership.type.name}</h5>
                                </a>
                            ) : (
                                <>
                                    <img src={membership.type.logo} alt={membership.type.name} style={{ width: '80px', marginBottom: '10px' }} />
                                    <RowSpacer size={5}/>
                                    <h5 className="text-center mb-0">{membership.type.name}</h5>
                                </>
                            )}
                        </div>

                        {/* Form - Right on desktop, Bottom on mobile */}
                        <div className="col-12 col-md-6">
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="도서관 홈페이지 아이디"
                                        value={homePageId}
                                        onChange={(e) => setHomePageId(e.target.value)}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="password"
                                        placeholder="도서관 홈페이지 비밀번호"
                                        value={homePagePw}
                                        onChange={(e) => setHomePagePw(e.target.value)}
                                        autoComplete="off"
                                    />
                                </Form.Group>
                                <Button
                                    variant="book"
                                    type="submit"
                                    disabled={!homePageId.trim() || !homePagePw.trim() || isSubmitting}
                                    className="w-100"
                                >
                                    {isSubmitting ? '저장 중...' : '저장'}
                                </Button>
                            </Form>
                        </div>
                    </div>
                </CardBodyContentContainer>
            </Card>
        )
    }

    const { status } = membership
    return (
        <Card style={{minHeight: '200px'}}>
            <CardBodyContentContainer height={200} backgroundColorType={'card'}>
                <CardTitle icon={<BooksitoutIcon.book/>} title={`대출 현황`} subTitle={undefined} textSize={2} url={''}/>

                <div style={{padding: '20px', textAlign: 'center'}}>
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                        <Badge bg="book" style={{fontSize: '1.2rem', padding: '8px 16px'}}>
                            현재 대출: {status.currentLoanCount} / {status.maxLoanCount}권
                        </Badge>

                        <Badge bg="book" style={{fontSize: '1.2rem', padding: '8px 16px'}}>
                            연체: {status.overdueCount}권
                            {status.isOverdue && ` (${status.overdueDayCount}일)`}
                        </Badge>

                        <Badge bg="book" style={{fontSize: '1.2rem', padding: '8px 16px'}}>
                            예약: {status.reservationCount}권
                        </Badge>
                    </div>
                </div>
            </CardBodyContentContainer>
        </Card>
    )
}
export default LibraryMembershipDetailStatusCard
